import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rootRoute } from './_root';

// Public Final Client Details Form (share-link token).
// PRD: apps/itineraries/prd/final-client-details-form.md
// URL: /final-client-form/$formId?token=...
//
// The FORM id is in the path, not the itinerary id, so the link does not
// disclose which itinerary it belongs to.

type FinalClientFormSearch = {
  token?: string;
};

const validateFinalClientFormSearch = (
  input: Record<string, unknown>
): FinalClientFormSearch => ({
  token: typeof input.token === 'string' ? input.token : undefined,
});

export const finalClientFormRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'final-client-form/$formId',
  validateSearch: validateFinalClientFormSearch,
  // Token in query string — do not leak via Referer.
  head: () => ({
    meta: [{ name: 'referrer', content: 'no-referrer' }],
  }),
  component: lazyRouteComponent(() =>
    import('@itineraries/pages/final-client-form').then((m) => ({
      default: m.FinalClientFormPage,
    }))
  ),
});
